import PasswordInput from '../../PasswordInput';
import { AuthField, AuthHint, AuthLabel } from '../../authModal.styles';

const AuthPasswordRegisterFields = ({
	password,
	confirmPassword,
	onPasswordChange,
	onConfirmPasswordChange,
	isAuthPending,
	isAuthSuccess,
	translations,
}) => (
	<>
		<AuthField>
			<AuthLabel htmlFor="auth-password-register">
				{translations.passwordLabelRegister || 'Set Password'}
			</AuthLabel>
			<PasswordInput
				id="auth-password-register"
				placeholder={
					translations.passwordPlaceholder || 'enter new password'
				}
				value={password}
				onChange={(event) => onPasswordChange(event.target.value)}
				minLength={6}
				disabled={isAuthPending || isAuthSuccess}
				showPasswordLabel={translations.showPassword}
				hidePasswordLabel={translations.hidePassword}
				autoComplete="new-password"
			/>
			<AuthHint>
				{translations.passwordRequirements || 'At least 6 characters.'}
			</AuthHint>
		</AuthField>
		<AuthField>
			<AuthLabel htmlFor="auth-confirm-password">
				{translations.confirmPasswordLabel || 'Confirm Password'}
			</AuthLabel>
			<PasswordInput
				id="auth-confirm-password"
				placeholder={
					translations.confirmPasswordPlaceholder || 'repeat new password'
				}
				value={confirmPassword}
				onChange={(event) => onConfirmPasswordChange(event.target.value)}
				minLength={6}
				disabled={isAuthPending || isAuthSuccess}
				showPasswordLabel={translations.showPassword}
				hidePasswordLabel={translations.hidePassword}
				autoComplete="new-password"
			/>
		</AuthField>
	</>
);

export default AuthPasswordRegisterFields;
